import React from "react";

import PaylaterSettingsList from "./paylaterSettingsList/PaylaterSettingsList";

const PaylaterSettings = () => {
  return <PaylaterSettingsList />;
};

export default PaylaterSettings;
